document.addEventListener("DOMContentLoaded", function () {
  if (
    document.body.classList.contains("single-property") ||
    document.body.classList.contains("page-id-739") ||
    document.body.classList.contains("page-id-737") ||
    document.body.classList.contains("single-yacht") ||
    document.body.classList.contains("single-car")
  ) {
    const openBtn = document.getElementById("openModalBtn");
    const closeBtn = document.getElementById("closeModalBtn");
    const modal = document.getElementById("formModal");

    openBtn.addEventListener("click", function () {
      modal.classList.remove("hidden");
    });

    closeBtn.addEventListener("click", function () {
      modal.classList.add("hidden");
    });

    // Optional: Close on outside click
    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        modal.classList.add("hidden");
      }
    });
  }
});
